export const local = {
    
     isMockNafath: true,
    apiUrl: 'http://localhost:5127',
    chatHubUrl:'https://localhost:44318/chatHub',
    websocketUrlInfraLink: 'wss://api.gravitee.dev.abraj.azm-dev.com/ibs-building/ws',
    notificationUrl: 'https://api.gravitee.dev.abraj.azm-dev.com/ns/api/inapp-notification',
    nafathMockUrl: 'http://localhost:7067', 
    nafathUrl: 'https://auth.dev.abraj.azm-dev.com/api', 
    websocketUrlUserManagement: 'wss://api.gravitee.dev.abraj.azm-dev.com/auth/ws',
    landLordURL:'https://landlord.dev.abraj.azm-dev.com/requests',
    mnoURL:'http://localhost:4202',
    nhpURL:'http://localhost:4203',
    adminURL:'http://localhost:4200',
    cstURL:'https://cst.dev.abraj.azm-dev.com/requests',
    eSignUrl:'https://api.gravitee.dev.abraj.azm-dev.com/esign',
    publicSite:'https://public.dev.abraj.azm-dev.com/',
    paymentApi: 'http://localhost:5043'

};

export const development = {
    isMockNafath: true,
    apiUrl: 'https://api.gravitee.dev.abraj.azm-dev.com/ibs-building',
    chatHubUrl:'https://localhost:44318/chatHub',
    websocketUrlInfraLink: 'wss://api.gravitee.dev.abraj.azm-dev.com/ibs-building/ws',
    notificationUrl: 'https://api.gravitee.dev.abraj.azm-dev.com/ns/api/inapp-notification',
    nafathMockUrl: 'https://api.gravitee.dev.abraj.azm-dev.com/auth', 
    nafathUrl: 'https://auth.dev.abraj.azm-dev.com/api', 
    websocketUrlUserManagement: 'wss://api.gravitee.dev.abraj.azm-dev.com/auth/ws',
    landLordURL:'https://landlord.dev.abraj.azm-dev.com/requests',
    mnoURL:'https://seeker.dev.abraj.azm-dev.com/requests',
    nhpURL:'https://provider.dev.abraj.azm-dev.com/requests',
    adminURL:'https://admin.dev.abraj.azm-dev.com/requests',
    cstURL:'https://cst.dev.abraj.azm-dev.com/requests',
    eSignUrl:'https://api.gravitee.dev.abraj.azm-dev.com/esign',
    publicSite:'https://public.dev.abraj.azm-dev.com/',
    paymentApi: 'https://api.gravitee.dev.abraj.azm-dev.com/payments'
}

export const staging = {
	isMockNafath: true,
    apiUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/ibs-building',
    chatHubUrl:'https://gateway-gravitee.qa.abraj.azm-dev.com/chat-api/chatHub',
    websocketUrlInfraLink: 'wss://gateway-gravitee.qa.abraj.azm-dev.com/ibs-building/ws',
    notificationUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/ns/api/inapp-notification',
    nafathMockUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/auth',
    nafathUrl: 'https://auth.qa.abraj.azm-dev.com/api',
    websocketUrlUserManagement: 'wss://gateway-gravitee.qa.abraj.azm-dev.com/auth/ws',
    landLordURL:'https://landlord.qa.abraj.azm-dev.com/requests',
    mnoURL:'https://seeker.qa.abraj.azm-dev.com/requests',
    nhpURL:'https://provider.qa.abraj.azm-dev.com/requests',
    adminURL:'https://admin.qa.abraj.azm-dev.com/requests',
    eSignUrl:'https://gateway-gravitee.qa.abraj.azm-dev.com/esign',
    cstURL:'https://cst.qa.abraj.azm-dev.com/requests',
    publicSite:'https://public.qa.abraj.azm-dev.com',
    paymentApi: 'https://gateway-gravitee.qa.abraj.azm-dev.com/payments'
};

export const uat = {
    isMockNafath: true,
    apiUrl: 'https://gateway-gravitee.uat.infrareg.sa/ibs-building',
    chatHubUrl:'https://gateway-gravitee.uat.infrareg.sa/chat-api/chatHub',
    websocketUrlInfraLink: 'wss://gateway-gravitee.uat.infrareg.sa/ibs-building/ws',
    notificationUrl: 'https://gateway-gravitee.uat.infrareg.sa/ns/api/inapp-notification',
    nafathMockUrl: 'https://gateway-gravitee.uat.infrareg.sa/auth',
    websocketUrlUserManagement: 'wss://gateway-gravitee.uat.infrareg.sa/auth/ws',
    nafathUrl: 'https://gateway-gravitee.uat.infrareg.sa/auth',
    landLordURL:'https://landlord.uat.infrareg.sa/requests',
    mnoURL:'https://seeker.uat.infrareg.sa/requests',
    nhpURL:'https://provider.uat.infrareg.sa/requests',
    adminURL:'https://admin.uat.infrareg.sa/requests',
    cstURL:'https://cst.uat.infrareg.sa/',
    eSignUrl:'https://gateway-gravitee.uat.infrareg.sa/esign',
    publicSite:'https://public.uat.infrareg.sa/',
    paymentApi: 'https://gateway-gravitee.uat.infrareg.sa/payments'
}

export const production = {
    isMockNafath: true,
    apiUrl: 'https://gateway-gravitee.infrareg.sa/ibs-building',
    chatHubUrl:'https://gateway-gravitee.infrareg.sa/chat-api/chatHub',
    websocketUrlInfraLink: 'wss://gateway-gravitee.infrareg.sa/ibs-building/ws',
    notificationUrl: 'https://gateway-gravitee.infrareg.sa/ns/api/inapp-notification',
    nafathMockUrl: 'https://gateway-gravitee.infrareg.sa/auth',
    websocketUrlUserManagement: 'wss://gateway-gravitee.infrareg.sa/auth/ws',
    nafathUrl: 'https://gateway-gravitee.infrareg.sa/auth',
    landLordURL:'https://landlord.infrareg.sa/requests',
    mnoURL:'https://seeker.infrareg.sa/requests',
    nhpURL:'https://provider.infrareg.sa/requests',
    adminURL:'https://admin.infrareg.sa/requests',
    cstURL:'https://cst.infrareg.sa/',
    eSignUrl:'https://gateway-gravitee.infrareg.sa/esign',
    publicSite:'https://public.infrareg.sa/',
    paymentApi: 'https://gateway-gravitee.infrareg.sa/payments'
};

